import { ACTION_TYPE } from './action';

// region Reducer
const systemUserDetail = (state = {}, action) => {
  switch (action.type) {
    case ACTION_TYPE.CALL_API_SYSTEM_USER_CREATE_SUCCESS:
      return {
        ...state,
        resultData: action.data,
        isCreateSuccess: true,
      };
    case ACTION_TYPE.CALL_API_SYSTEM_USER_UPDATE_SUCCESS:
      return {
        ...state,
        resultData: action.data,
        isUpdateSuccess: true,
      };
    case ACTION_TYPE.CALL_API_GET_SYSTEM_USER_SUCCESS:
      return {
        ...state,
        data: action.data,
      };
    case ACTION_TYPE.CALL_API_SYSTEM_USER_MAIL_CHECK_SUCCESS:
      return {
        ...state,
        mail: action.data,
      };
    case ACTION_TYPE.RESET_SYSTEM_USER_DETAIL_FLG:
      return {
        ...state,
        isDeleteSuccess: false,
        isCreateSuccess: false,
        isUpdateSuccess: false,
      };
    default:
      return state;
  }
};

export default systemUserDetail;
